import React from "react"
import Video from "@/components/Video"
import SupportArticleAssetWrapper from "@/components/SupportArticleAssetWrapper"

const SupportVideo = ({ src, alt }) => {
  return (
    <SupportArticleAssetWrapper>
      <Video file={require(`@/videos/support/${src}.mp4`)} alt={alt} />
    </SupportArticleAssetWrapper>
  )
}

export default SupportVideo
